import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListExcelExportFile, ListExcelExportRequest } from '@common/models/common/ListExcelExport.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContainerVisitService {
    constructor(private http: HttpClient) {}

    getContainerVisitList(filter: any) {
        return this.http.post('api:///ContainerVisit/GetContainerVisitList', filter);
    }

    exportContainerVisitList(body: ListExcelExportRequest): Observable<ListExcelExportFile> {
        return this.http.post<ListExcelExportFile>('api:///ContainerVisit/ExportContainerVisitList', body);
    }

    getContainerVisit(id: number) {
        return this.http.get<any>(`api:///ContainerVisit/GetContainerVisit/${id}`);
    }

    getServiceRequests(containerVisitId: number) {
        return this.http.get<any>(`api:///ContainerVisit/GetServiceRequests/${containerVisitId}`);
    }

    getSeals(containerVisitId: number) {
        return this.http.get<{ inbound: any[]; outbound: any[] }>(`api:///ContainerVisit/GetSeals/${containerVisitId}`);
    }

    getContainerMoves(containerVisitId: number) {
        return this.http.get<any>(`api:///ContainerVisit/GetContainerMoves/${containerVisitId}`);
    }

    getVesselVisitsForContainers() {
        return this.http.get<any>(`api:///ContainerVisit/GetVesselVisitsForContainers`);
    }

    confirmContainerMove(model: { performedDate: string; name: string; versionContainerId: number }) {
        return this.http.post<any>(`api:///ContainerVisit/ConfirmContainerMove`, model);
    }

    cancelContainerMove(model: any) {
        return this.http.post<any>(`api:///ContainerVisit/CancelContainerMove`, model);
    }

    uncofirmContainerMoves(model: any) {
        return this.http.post<any>(`api:///ContainerVisit/UnconfirmContainerMoves`, model);
    }

    holdContainerVisits(model: any) {
        return this.http.post<any>(`api:///ContainerVisit/HoldContainerVisits`, model);
    }
}
